import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
} from '@angular/core';
import { BaseComponent } from '@shared/components/base-component/base.component';
import { TabModel } from '@shared/model/tab.model';
import { TabLabel } from "@shared/enums/tab-label.enum";
import { LocationsApiService } from '@shared-features/services/locations-api.service';
import { Lookup } from '@shared-features/models/Lookup.model';
import { LocationType } from "@shared/enums/location-type.enum";
import debounce from 'lodash/debounce';
import { LocationModel } from '@features/live-tracking/models/location.model';
import { Tracking } from '@features/live-tracking/models/tracking-driver';

@Component({
  selector: 'app-shipment-smart-detection',
  templateUrl: './shipment-smart-detection.component.html',
  styleUrls: ['./shipment-smart-detection.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ShipmentSmartDetectionComponent extends BaseComponent implements OnInit, OnChanges {
  @Input() fromLocation: Lookup;
  @Input() customerId: number;
  @Output() closeModal = new EventEmitter();
  @Output() save = new EventEmitter();
  @Output() selectDriver = new EventEmitter();
  driver: Tracking;
  status: string;
  pickupLocation: LocationModel;

  currentTabIndex = 0;
  selectedTabIndex = 0;
  tabs: TabModel[] = [
    {
      label: TabLabel.Online,
      showCount: false,
    },
    {
      label: TabLabel.Offline,
      showCount: false,
    },
  ];

  constructor(
    private locationsApiService: LocationsApiService,
    private changeDetector: ChangeDetectorRef,
  ) {
    super();
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.load(
      this.locationsApiService.getLocations(LocationType.Customer, this.customerId)
    ).subscribe((locations) => {
      this.pickupLocation = locations.find((location) => location.id === this.fromLocation.id);
      this.changeDetector.markForCheck();
    });
  }

  ngOnChanges(): void {
    debounce(() => this.changeDetector.markForCheck(), 300);
  }

  getCurrentTabIndex(event: number): void {
    this.currentTabIndex = event;
    this.driver = null;
    this.changeDetector.markForCheck();
  }

  handleSelectedDriver(selectedDriver: Tracking): void {
    this.driver = selectedDriver;
    this.changeDetector.markForCheck();
  }

  onClickSave(): void {
    this.selectDriver.emit(this.driver);
    this.save.emit();
    this.closeModal.emit();
    this.changeDetector.markForCheck();
  }
}
